import React from 'react';
import PageHero from '../components/layout/PageHero';
import { ToolGuideCta } from '../components/layout/GuideLayout';
import FuelConsumptionConverter from '../components/tools/FuelConsumptionConverter';
import { usePageSeo } from '../hooks/usePageSeo';

const PAGE_TITLE = 'Fuel Consumption & CO₂ Converter | L/100km, mpg, kWh/100km | AUTOXIUM';
const PAGE_DESCRIPTION = 'Convert fuel economy between L/100 km, km/L, mpg (US) and mpg (UK), and EV efficiency between kWh/100 km, Wh/km, km/kWh, mi/kWh and MPGe, with tank-to-wheel CO₂ per km for petrol, diesel, LPG, CNG and grid electricity.';

const FuelConsumptionConverterPage = () => {
  usePageSeo(PAGE_TITLE, PAGE_DESCRIPTION);

  return (
    <div className="min-h-screen" data-testid="fuel-consumption-converter-page">
      <PageHero
        eyebrow="Engineering Utilities / Conversion"
        title="Fuel Consumption & CO₂ Converter"
        description="Convert fuel or electric efficiency between metric, US and UK units, and estimate tank-to-wheel CO₂ per kilometre. Enter a value in any unit and the rest update in real time."
        backTo="/tools"
        backLabel="Back to Tools"
        testId="fuel-consumption-converter-hero"
      />
      <section className="py-12 md:py-16">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8">
          <FuelConsumptionConverter />
          <ToolGuideCta guidePath="/tools/fuel-consumption-calculator/guide" toolName="Fuel Consumption & CO₂ Converter" />
        </div>
      </section>
    </div>
  );
};

export default FuelConsumptionConverterPage;
